import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { startWith, take } from 'rxjs';
import { FieldConfig } from '@smartflip/data-models';
import { RoiService } from '@smartflip/ui-utils';
import { summaryFields } from '@smartflip/data-field-configuration';
import { PropertyDetailsService } from '../../property-details.service';

@Component({
  selector: 'app-cost-details',
  templateUrl: './cost-details.component.html',
  styleUrls: ['./cost-details.component.scss'],
  standalone: false,
})
export class CostDetailsComponent implements OnInit {
  @Input() propertyId: string;

  public homeFieldList: FieldConfig[];
  public summaryForm: UntypedFormGroup;
  public profitMessage = 'enter sell price to calculate profit';
  public displayAddress$ = this.propService.displayAddress$;

  constructor(
    public roi: RoiService,
    private propService: PropertyDetailsService,
  ) {}

  ngOnInit() {
    this.propService.propertyIsSet$.pipe(take(1)).subscribe((propSetVal) => {
      if (propSetVal) {
        const summaryForm = this.roi.formGroups['gen'];

        this.homeFieldList = [...summaryFields];
        this.summaryForm = this.roi.formGroups.summary;
        summaryForm.valueChanges
          .pipe(startWith(null))
          .subscribe(this.updateEstimatedStatus.bind(this));
      }
    });
  }

  private updateEstimatedStatus() {
    const summaryForm = this.roi.formGroups['gen'];
    const disableAbleFields = ['price', 'sell'];

    this.homeFieldList = this.homeFieldList.map((field) => {
      const fieldIsEstimated =
        (field.name === 'price' && !summaryForm.value?.purchasedate) ||
        (field.name === 'sell' && !summaryForm.value?.solddate);

      return {
        ...field,
        label: fieldIsEstimated ? field.label + ' (est)' : field.label,
        disabled: !fieldIsEstimated && disableAbleFields.includes(field.name),
      };
    });
  }
}
